var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132-312h696q15 0 25.5 10.5T864-276q0 15-10.5 25.5T828-240H132q-15 0-25.5-10.5T96-276q0-15 10.5-25.5T132-312Zm36-214-11 19q-8 13-22 17t-27-4q-13-8-17-22t4-27l11-19H84q-15 0-25.5-10.5T48-598q0-15 10.5-25.5T84-634h22l-11-19q-8-13-4-27t17-22q13-8 27-4t22 17l11 19 11-19q8-13 22-17t27 4q13 8 17 22t-4 27l-11 19h22q15 0 25.5 10.5T288-598q0 15-10.5 25.5T252-562h-22l11 19q8 13 4 27t-17 22q-13 8-27 4t-22-17l-11-19Zm312 0-11 19q-8 13-22 17t-27-4q-13-8-17-22t4-27l11-19h-22q-15 0-25.5-10.5T360-598q0-15 10.5-25.5T396-634h22l-11-19q-8-13-4-27t17-22q13-8 27-4t22 17l11 19 11-19q8-13 22-17t27 4q13 8 17 22t-4 27l-11 19h22q15 0 25.5 10.5T600-598q0 15-10.5 25.5T564-562h-22l11 19q8 13 4 27t-17 22q-13 8-27 4t-22-17l-11-19Zm312 0-11 19q-8 13-22 17t-27-4q-13-8-17-22t4-27l11-19h-22q-15 0-25.5-10.5T672-598q0-15 10.5-25.5T708-634h22l-11-19q-8-13-4-27t17-22q13-8 27-4t22 17l11 19 11-19q8-13 22-17t27 4q13 8 17 22t-4 27l-11 19h22q15 0 25.5 10.5T912-598q0 15-10.5 25.5T876-562h-22l11 19q8 13 4 27t-17 22q-13 8-27 4t-22-17l-11-19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d5d8f271b29bed3ac5cc0641734b6bb0.svg";
export { ForwardRef as ReactComponent };